import { render, staticRenderFns } from "./SlideImageCompare.vue?vue&type=template&id=3b6230c2&scoped=true&"
import script from "./SlideImageCompare.vue?vue&type=script&lang=ts&"
export * from "./SlideImageCompare.vue?vue&type=script&lang=ts&"
import style0 from "./SlideImageCompare.vue?vue&type=style&index=0&id=3b6230c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6230c2",
  null
  
)

export default component.exports